import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import MuiDialog, { DialogProps } from '@mui/material/Dialog';
import Button, { Props as ButtonProps } from '@classify/react-core-components/Button';
import Typography from '@classify/react-core-components/Typography';
import Stack from '@classify/react-core-components/Stack';
import { styled } from '../styles';
const Title = styled(Typography)(({
  theme: {
    spacing
  }
}) => ({
  padding: spacing(3, 3, 2, 3)
}));
const ActionsWrapper = styled(Stack)(({
  theme: {
    spacing
  }
}) => ({
  padding: spacing(2),
  justifyContent: 'flex-start'
}));
const ButtonWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end'
});
const Content = styled('div')(({
  theme: {
    spacing
  }
}) => ({
  width: '100%',
  flexGrow: 1,
  overflow: 'auto',
  padding: spacing(0, 3),
  boxSizing: 'border-box'
}));
export interface Props extends Pick<DialogProps, 'sx' | 'children' | 'onClose'> {
  isOpen: boolean;
  translations?: {
    title?: string;
  };
  confirmButtonProps?: ButtonProps;
  dismissButtonProps?: Omit<ButtonProps, 'variant'>;
}
const Dialog = t0 => {
  const $ = _c(31);
  let children;
  let confirmButtonProps;
  let dismissButtonProps;
  let isOpen;
  let onClose;
  let otherProps;
  let translations;
  if ($[0] !== t0) {
    ({
      isOpen,
      children,
      onClose,
      translations,
      confirmButtonProps,
      dismissButtonProps,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = confirmButtonProps;
    $[3] = dismissButtonProps;
    $[4] = isOpen;
    $[5] = onClose;
    $[6] = otherProps;
    $[7] = translations;
  } else {
    children = $[1];
    confirmButtonProps = $[2];
    dismissButtonProps = $[3];
    isOpen = $[4];
    onClose = $[5];
    otherProps = $[6];
    translations = $[7];
  }
  const titleId = `dialog-title-${useId()}`;
  let t1;
  if ($[8] !== onClose) {
    t1 = (event, reason) => onClose?.(event, reason);
    $[8] = onClose;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const handleClose = t1;
  const hasButtons = confirmButtonProps || dismissButtonProps;
  let t2;
  if ($[10] !== titleId || $[11] !== translations?.title) {
    t2 = translations?.title && <Title id={titleId} component="h1" variant="h5">{translations?.title}</Title>;
    $[10] = titleId;
    $[11] = translations?.title;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const t3 = translations?.title ? 0 : 3;
  const t4 = hasButtons ? 0 : 3;
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = {
      marginTop: t3,
      marginBottom: t4
    };
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== children || $[17] !== t5) {
    t6 = <Content sx={t5}>{children}</Content>;
    $[16] = children;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== confirmButtonProps || $[20] !== dismissButtonProps || $[21] !== hasButtons) {
    t7 = hasButtons && <ActionsWrapper direction={{
      xs: "column",
      sm: "row-reverse"
    }} gap={{
      xs: 1,
      sm: 2
    }}>{confirmButtonProps && <ButtonWrapper><Button variant="tertiary" {...confirmButtonProps} /></ButtonWrapper>}{dismissButtonProps && <ButtonWrapper><Button variant="tertiary" {...dismissButtonProps} /></ButtonWrapper>}</ActionsWrapper>;
    $[19] = confirmButtonProps;
    $[20] = dismissButtonProps;
    $[21] = hasButtons;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== handleClose || $[24] !== isOpen || $[25] !== otherProps || $[26] !== t2 || $[27] !== t6 || $[28] !== t7 || $[29] !== titleId) {
    t8 = <MuiDialog open={isOpen} onClose={handleClose} aria-labelledby={titleId} {...otherProps}>{t2}{t6}{t7}</MuiDialog>;
    $[23] = handleClose;
    $[24] = isOpen;
    $[25] = otherProps;
    $[26] = t2;
    $[27] = t6;
    $[28] = t7;
    $[29] = titleId;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
};
export default Dialog;